import React from "react"
import ImageShow from "../ImageShow/showImage"
import ScrollButton from "../buttons/scrollButton/scrollButton"
import * as style from "./webinarBanner.module.css"

const WebinarBanner = ({
  handleClick,
  isLoggedIn,
  bannerButtonTitle,
  bannerText,
  bannerSubtitle,
  bannerTitle,
  bannerImage,
  comingSoonWebinar,
}) => {
  return (
    <section className={style.webinarbanner}>
      <div className="container">
        <div className={style.banner_wrapper}>
          <div className={style.col_6}>
            <span className={style.span_title}>Webinar</span>
            <h1>
              {" "}
              <span>{bannerTitle}</span> {bannerSubtitle}
            </h1>
            <p> {bannerText} </p>
            {comingSoonWebinar === "yes" && (
              <ScrollButton
                onClick={() => handleClick(1)}
                customClass="webinar-btn m-0 w-auto-imp"
                btnText={bannerButtonTitle}
                data-aos="fade-up"
                data-aos-delay="100"
              />
            )}
          </div>
          <div className={style.col_6}>
            <ImageShow
              imgTagClass={style.quoteImage}
              imageData={
                bannerImage.mediaItemUrl
                  ? bannerImage.mediaItemUrl
                  : "/images/placeholder-image.jpg"
              }
              alt={bannerImage.altText}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default WebinarBanner
